export default __webpack_public_path__ + "static/media/contact.66fde53f.png";